import React, { useEffect, useMemo, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import { useNavigate } from "react-router-dom";
import "./RespostasRapidas.css";

export default function RespostasRapidas() {
  const [lista, setLista] = useState([]);
  const [busca, setBusca] = useState("");
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [form, setForm] = useState({
  id: null,
  atalho: "/novo",
  titulo: "",
  conteudo: "",
  arquivo: null,
  arquivo_url: "",
  arquivo_nome: "",
  arquivo_tipo: "",
  remover_arquivo: 0,
});
  const navigate = useNavigate();
    const tituloRef = useRef(null);
    const conteudoRef = useRef(null);
    const [pickerAberto, setPickerAberto] = useState(null);
    const [mostrarPicker, setMostrarPicker] = useState(false);


      const inserirNoCursor = (ref, valor) => {
   const el = ref?.current;
    if (!el) return;
    const start = el.selectionStart ?? el.value.length;
    const end = el.selectionEnd ?? el.value.length;
    const texto = el.value;
    const novo = texto.slice(0, start) + valor + texto.slice(end);
    el.value = novo;
    // atualiza form de acordo com o campo
    if (ref === tituloRef) setForm((f) => ({ ...f, titulo: novo }));
    if (ref === conteudoRef) setForm((f) => ({ ...f, conteudo: novo }));
    // reposiciona o caret
    const pos = start + valor.length;
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(pos, pos);
    });
  };

function parseWhatsAppHTML(text) {
  if (!text) return "";

  // ESCAPA HTML primeiro (segurança)
  let s = String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  // preserva quebras de linha (se quiser como no chat)
  s = s.replace(/\n/g, "<br/>");

  // **negrito** ou *negrito*
  s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  s = s.replace(/\*(.+?)\*/g, "<strong>$1</strong>");

  // __negrito__ (alguns usam) — opcional
  s = s.replace(/__(.+?)__/g, "<strong>$1</strong>");

  // _itálico_  (evita pegar underscore no meio de palavra)
  s = s.replace(/(^|[^_])_(.+?)_([^_]|$)/g, "$1<em>$2</em>$3");

  // ~~riscado~~ ou ~riscado~
  s = s.replace(/~~(.+?)~~/g, "<del>$1</del>");
  s = s.replace(/~(.+?)~/g, "<del>$1</del>");

  // `monospace`
  s = s.replace(/`(.+?)`/g, "<code>$1</code>");

  return s;
}


  const load = async (q = "") => {
    setLoading(true);
    setErro("");
    try {
      const res = await fetch(
        `/crm-wly/api/whatsapp/respostas_rapidas.php${q ? `?q=${encodeURIComponent(q)}` : ""}`,
        { credentials: "include" }
      );
      const data = await res.json();
      if (data?.success && Array.isArray(data.data)) setLista(data.data);
      else throw new Error(data?.error || "Falha ao listar");
    } catch (e) {
      setErro(e.message);
      setLista([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const editar = (r) =>
  setForm({
    id: r.id,
    atalho: r.atalho || "/novo",
    titulo: r.titulo || "",
    conteudo: r.conteudo || "",
    arquivo: null,
    arquivo_url: r.arquivo_url || "",
    arquivo_nome: r.arquivo_nome || "",
    arquivo_tipo: r.arquivo_tipo || "",
    remover_arquivo: 0,
  });
  const cancelarEdicao = () =>
  setForm({
    id: null,
    atalho: "/novo",
    titulo: "",
    conteudo: "",
    arquivo: null,
    arquivo_url: "",
    arquivo_nome: "",
    arquivo_tipo: "",
    remover_arquivo: 0,
  });

  useEffect(() => { setPickerAberto(null); }, [form.id]);

 const salvar = async () => {
  setErro("");

const temConteudo = !!form.conteudo?.trim();
const temArquivo = !!form.arquivo || !!form.arquivo_url;

if (!form.atalho?.startsWith("/") || !form.titulo?.trim() || (!temConteudo && !temArquivo)) {
  setErro("Preencha o atalho iniciando com '/', o título e informe um conteúdo ou um arquivo.");
  return;
}

  setSalvando(true);

  try {
    let res;

    const temArquivoNovo = !!form.arquivo;

    if (temArquivoNovo) {
      const fd = new FormData();
      fd.append("atalho", form.atalho);
      fd.append("titulo", form.titulo);
      fd.append("conteudo", form.conteudo);
      fd.append("arquivo", form.arquivo);

      if (form.id) {
        fd.append("_method", "PUT");
        fd.append("id", String(form.id));
      }

      if (form.remover_arquivo) {
        fd.append("remover_arquivo", "1");
      }

      res = await fetch("/crm-wly/api/whatsapp/respostas_rapidas.php", {
        method: "POST",
        credentials: "include",
        body: fd,
      });
    } else {
      const payload = {
        id: form.id,
        atalho: form.atalho,
        titulo: form.titulo,
        conteudo: form.conteudo,
        remover_arquivo: form.remover_arquivo || 0,
      };

      res = await fetch("/crm-wly/api/whatsapp/respostas_rapidas.php", {
        method: form.id ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });
    }

    const data = await res.json();

    if (!res.ok || !data?.success) {
      throw new Error(data?.error || "Erro ao salvar.");
    }

    cancelarEdicao();
    await load(busca);
  } catch (e) {
    setErro(e.message || "Erro ao salvar.");
  } finally {
    setSalvando(false);
  }
};

  const excluir = async (id) => {
    if (!window.confirm("Excluir esta resposta rápida?")) return;
    setErro("");
    try {
      const res = await fetch("/crm-wly/api/whatsapp/respostas_rapidas.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ id }),
      });
      if (!res.ok) throw new Error("Erro ao excluir");
      await load(busca);
    } catch (e) {
      setErro(e.message);
    }
  };

const preview = useMemo(() => {
  const texto = String(form.conteudo || "").trim();

  if (texto) {
    return texto.slice(0, 120) + (texto.length > 120 ? "…" : "");
  }

  if (form.arquivo_nome || form.arquivo_url) {
    return "[Resposta rápida com arquivo]";
  }

  return "—";
}, [form.conteudo, form.arquivo_nome, form.arquivo_url]);

  return (
    <div className="rr-titulo">
        <h1>Respostas Rápidas</h1>

        <div className="rr-container">
      <div className="rr-header">
                <div className="rr-actions">
          <button className="btn-voltar-rr"  onClick={() => navigate('/wzp/painel-mensagens')}>
            ← Voltar ao Chat
          </button>
        </div>
      </div>

      <div className="rr-toolbar">
        <input
          className="rr-input"
          placeholder="Buscar por atalho ou título…"
          value={busca}
          onChange={(e) => setBusca(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load(busca)}
        />
        <button className="rr-primary" onClick={() => load(busca)}>Buscar</button>
        <button className="rr-limpar" onClick={() => { setBusca(""); load(""); }}>Limpar</button>
      </div>

      <div className="rr-editor">
        <div className="rr-row">
          <div className="rr-col">
            <label>Atalho *</label>
            <input
              className="rr-input"
              placeholder="/atalho"
              value={form.atalho}
              onChange={(e) => setForm({ ...form, atalho: e.target.value })}
            />
          </div>
          <div className="rr-col">
            <label>Título *</label>
            <div style={{ position: "relative" }}>
           <input
              className="rr-input"
              placeholder="Ex.: Apresentação"
              value={form.titulo}
              ref={tituloRef}
              onChange={(e) => setForm({ ...form, titulo: e.target.value })}
            />    
            </div>
          </div>
        </div>

         <div style={{ position: "relative" }}>
            <textarea
              ref={conteudoRef}
              className="rr-textarea"
              rows={5}
              placeholder="Mensagem opcional. Você pode cadastrar só um arquivo, se quiser…"
              value={form.conteudo}
              onChange={(e) => setForm({ ...form, conteudo: e.target.value })}
              style={{ paddingBottom: "35px" }}
            />
          <button
            type="button"
            className="rr-emoji-btn"
            title="Inserir emoji"
            onClick={() => setMostrarPicker((v) => !v)}
            style={{
              position: "absolute",
              bottom: "5px",
              right: "10px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            😊
          </button>
          {mostrarPicker && (
            <div
              style={{
                position: "absolute",
                bottom: "45px",
                right: 0,
                zIndex: 1000,
              }}
            >
              <EmojiPicker
                onEmojiClick={(emoji) =>
                  setForm((f) => ({ ...f, conteudo: f.conteudo + emoji.emoji }))
                }
                autoFocusSearch={false}
                theme="light"
              />
            </div>
          )}

          <div className="rr-upload-box">
  <label>Anexo</label>

  <input
    type="file"
    className="rr-input"
    onChange={(e) => {
      const file = e.target.files?.[0] || null;
      if (!file) return;

      setForm((f) => ({
        ...f,
        arquivo: file,
        arquivo_nome: file.name,
        arquivo_tipo: file.type || "",
        remover_arquivo: 0,
      }));
    }}
  />

  {(form.arquivo_nome || form.arquivo_url) && (
    <div style={{ marginTop: "8px", display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
      <span>
        <strong>Arquivo:</strong> {form.arquivo_nome || "Anexo atual"}
      </span>

      {form.arquivo_url && !form.arquivo && (
        <a
          href={form.arquivo_url}
          target="_blank"
          rel="noreferrer"
          className="rr-secondary"
          style={{ textDecoration: "none", padding: "6px 10px" }}
        >
          Ver arquivo
        </a>
      )}

      <button
        type="button"
        className="rr-danger"
        onClick={() =>
          setForm((f) => ({
            ...f,
            arquivo: null,
            arquivo_url: "",
            arquivo_nome: "",
            arquivo_tipo: "",
            remover_arquivo: 1,
          }))
        }
      >
        Remover arquivo
      </button>
    </div>
  )}
</div>
        </div>

        <div className="rr-editor-footer">
          <div className="rr-preview">
            <span>Prévia:</span>
<span
  className="rr-preview-html"
  dangerouslySetInnerHTML={{ __html: parseWhatsAppHTML(preview || "—") }}
/>


          </div>
          <div className="rr-editor-buttons">
            {form.id && (
              <button className="rr-secondary" onClick={cancelarEdicao}>
                Cancelar
              </button>
            )}
            <button className="rr-primary" disabled={salvando} onClick={salvar}>
              {salvando ? "Salvando…" : form.id ? "Atualizar" : "Salvar"}
            </button>
          </div>
        </div>

        {erro && <div className="rr-error">{erro}</div>}
      </div>

      <div className="rr-list">
        {loading ? (
          <div className="rr-loading">Carregando…</div>
        ) : (
          <>
            {lista.length === 0 ? (
              <div className="rr-empty">Nenhuma resposta rápida encontrada.</div>
            ) : (
              <table className="rr-table">
                <thead>
                  <tr>
                    <th style={{ width: 140 }}>Atalho</th>
                    <th style={{ width: 220 }}>Título</th>
                    <th>Conteúdo</th>
                    <th style={{ width: 180 }}>Anexo</th>
                    <th style={{ width: 140, textAlign: "center" }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {lista.map((r) => (
                    <tr key={r.id}>
  <td>{r.atalho}</td>
  <td>{r.titulo}</td>
  <td
    className="rr-conteudo"
    dangerouslySetInnerHTML={{ __html: parseWhatsAppHTML(r.conteudo) }}
  />
  <td>
    {r.arquivo_url ? (
      <a href={r.arquivo_url} target="_blank" rel="noreferrer">
        {r.arquivo_nome || "Ver arquivo"}
      </a>
    ) : (
      "—"
    )}
  </td>
  <td className="rr-acoes">
    <button className="rr-editar" onClick={() => editar(r)}>Editar</button>
    <button className="rr-danger" onClick={() => excluir(r.id)}>Excluir</button>
  </td>
</tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
    </div>
  );
}
